import { useAllAreas } from "http-hooks/area/useArea";
import DeleteArea from "components/area/DeleteArea";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  areaname: "",
  ag_status: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "areaname", header: "Name" },
  {
    key: "ag_status",
    header: "Status",
    render: (item) => <StatusIcon value={item.ag_status} />,
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function AreaMaster() {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("area", id);

  const handleAreaSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, areaname: searchTerm, page: 1 }));
  };

  const handleStatusChange = (statusOption) => {
    setSelectedStatus(statusOption);
    setFilter((prev) => ({
      ...prev,
      ag_status: statusOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allAreas, page: currentPage, totalPages } = [],
  } = useAllAreas(filter);

  return (
    <MasterPage
      title="Area Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add Area</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleAreaSearch}
              label="Area Name"
              placeholder="Search Area Name"
            />
          </FilterCell>
          <FilterCell>
            <Select
              value={selectedStatus}
              onChange={handleStatusChange}
              options={statusOptions}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allAreas}
      isLoading={isLoading}
      rowKey="areaId"
      deleteComponent={DeleteArea}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.areaId)}
            title="Edit Area"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.areaId)}
            title="Delete Area"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
